import styled from 'styled-components'
import { Text } from 'rebass'
import { ReactComponent as MenuIcon } from '../../assets/images/menu.svg'
import { ExternalLink } from '../../theme'

export const AccountElement = styled.div<{ active: boolean }>`
  align-items: center;
  background-color: ${({ theme, active }) => (!active ? theme.bg3 : theme.bg4)};
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.small};
  cursor: pointer;
  display: flex;
  white-space: nowrap;
  width: 100%;

  :focus {
    border: 1px solid blue;
  }
`

export const BalanceText = styled(Text)`
  padding: 0 1rem;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `};
`
export const StyledMenuButton = styled.button`
  background-color: ${({ theme }) => theme.bg3};
  background-color: transparent;
  border: none;
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.smaller};
  height: 35px;
  margin: 0 5px;
  padding: 0.15rem 0.5rem;

  padding: 0;
  width: 100%;

  :hover,
  :focus {
    background-color: ${({ theme }) => theme.bg4};
    cursor: pointer;
    outline: none;
  }

  svg {
    margin-top: 2px;
  }
`

export const MenuIconWrapper = styled.div`
  background-color: rgba(128, 76, 238, 0.2);
  border-radius: 50%;
  display: flex;
  padding: 0.5rem;
  transition: ${({ theme }) => theme.TRANSITION.medium};

  &:hover {
    background-color: rgba(128, 76, 238, 0.3);
  }
`

export const StyledMenuIcon = styled(MenuIcon)`
  path {
    stroke: ${({ theme }) => theme.text1};
  }
`
export const MenuFlyout = styled.span`
  background-color: ${({ theme }) => theme.bg3};
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.smaller};
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  min-width: 8.125rem;
  padding: 0.5rem;
  position: absolute;
  right: 0;
  top: 0.5rem;
  z-index: 3;
`

export const MenuItem = styled(ExternalLink)`
  color: ${({ theme }) => theme.text2};
  flex: 1;
  padding: 0.5rem;

  :hover {
    color: ${({ theme }) => theme.primary1};
    cursor: pointer;
    text-decoration: none;
  }

  > svg {
    margin-right: 8px;
  }
`

export const Navbar = styled.nav`
  display: flex;
  height: 60px;
  justify-content: space-between;
  margin: auto;
  padding: 0 1rem;
`
export const NavbarWrapper = styled.div<{ isIndexPage: boolean }>`
  background-color: ${({ isIndexPage, theme }) => (isIndexPage ? 'transparent' : theme.drawerBG)};
  border-bottom: ${({ isIndexPage }) => (isIndexPage ? 0 : '2px solid rgba(133, 133, 133, 0.1)')};
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
  ${({ theme, isIndexPage }) => theme.mediaWidth.upToSmall`
    background-color: ${isIndexPage ? '#030202' : theme.drawerBG} ;
  `}
`

export const PurpleSide = styled.div`
  color: #d06cff;
  display: inline;
  font-weight: inherit;
`

export const Hamburger = styled.div`
  align-items: center;
  display: flex;
  font-size: 24px;
  justify-content: center;
`

export const BrandWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-left: 1rem;
  width: 100%;
`

export const Flex = styled.div`
  align-items: center;
  display: flex;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `}
`

export const DrkWht = styled.div`
  color: ${({ theme }) => theme.text1};
  display: inline;
  font-weight: 700;
`
